<script>
import { layoutComputed } from "@/state/helpers";
import Horizontal from "./horizontal";
import BannerApi from "@/services/banner-api";
import { mapGetters } from 'vuex';

export default {
  components: { /*Vertical ,*/ Horizontal },
  computed: {
    ...layoutComputed,
    ...mapGetters('notification', ['orderChangedLines', 'unpaidInvoices', 'upcomingDueInvoices', 'invoiceWithoutRS']),

      windowWidth() {
        return window.innerWidth;
      },

      maxPerRow() {
        if (this.windowWidth >= 1450) return 6; 
        if (this.windowWidth >= 1200) return 4;
        if (this.windowWidth >= 768) return 3; 
        if (this.windowWidth >= 540) return 2; 
        return 1;
      },

      visibleChangedOrderLines() {
        if (!Array.isArray(this.orderChangedLines) || this.orderChangedLines.length === 0) {
          return [];
        }

        return this.showAll
          ? this.orderChangedLines
          : this.orderChangedLines.slice(0, this.maxPerRow);
      },

      unpaidCount() {
        return Array.isArray(this.unpaidInvoices) ? this.unpaidInvoices.length : 0;
      },

      upcomingDueCount() {
        return Array.isArray(this.upcomingDueInvoices) ? this.upcomingDueInvoices.length : 0;
      },

      // subtitle end: "la prochaine dans 3 jours" / "la première arrive à échéance" (the server sends the list soonest due first)
      nextUpcomingDue() {
        if (!this.upcomingDueCount) return null;
        const days = Number(this.upcomingDueInvoices[0].remainingDaysToPay);
        if (!Number.isFinite(days)) return null;
        if (days <= 0) return 'la première arrive à échéance';
        return 'la prochaine dans ' + days + (days > 1 ? ' jours' : ' jour');
      },

      // invoice balances and due dates: suppliers and customer admins only, as in the invoices list
      canSeeInvoiceBalances() {
        let permissions = [];
        // $cookies.get already parses the JSON array; accept a raw string too
        try {
          const raw = this.$cookies.get('permission');
          permissions = Array.isArray(raw) ? raw : (JSON.parse(raw || '[]') || []);
        } catch (e) { permissions = []; }
        return this.role == 1 || (this.role == 0 && permissions.includes('CUSTOMER_ADMIN'));
      },

      rsCount() {
        return Array.isArray(this.invoiceWithoutRS) ? this.invoiceWithoutRS.length : 0;
      },

      changedLinesCount() {
        return Array.isArray(this.orderChangedLines) ? this.orderChangedLines.length : 0;
      },

      changedOrdersCount() {
        return Array.isArray(this.orderChangedLines) ? new Set(this.orderChangedLines.map((line) => line.numBc)).size : 0;
      },

      // Same visibility rule the notice rows have always used.
      canShowNotices() {
        // laboratory / partner accounts never see a pharmacy's financial or order alerts (the server sends none either)
        if (this.isPartner) return false;
        return (this.role == 1 && this.$route.path === '/catalogue')
            || (this.role == 0 && this.$route.path !== '/');
      },

      isChangedOrdernlinesEnabled(){
        return process.env.VUE_APP_FEATURE_CHANGED_ORDERLINES_ENABLED === 'true';
      },

      // CAB (VUE_APP_THEME=0, its own theme) keeps the "Commande modifiée" cards as they were before the banner
      isLegacyChangedOrderAlert(){
        return process.env.VUE_APP_THEME == 0;
      },

      isUnpaidInvoicesNotificationEnabled(){
        return process.env.VUE_APP_FEATURE_UNPAID_INVOICES_NOTIFICATION === 'true';
      },

      isUpcomingDueInvoicesNotificationEnabled(){
        return process.env.VUE_APP_FEATURE_UPCOMING_DUE_INVOICES_NOTIFICATION === 'true';
      },

      isInvoiceWithoutRsNotificationEnabled(){
        return process.env.VUE_APP_FEATURE_INVOICE_WITHOUT_RS_NOTIFICATION === 'true';
      },

      isBannerNewYearEnabled(){
        return process.env.VUE_APP_FEATURE_BANNER_NEW_YEAR_ENABLED === 'true';
      },

      envSupplierName(){
        return process.env.VUE_APP_CLIENT_NAME
      },

      role() {
        return this.$cookies.get('userr');
      },

      isPartner() {
        return String(this.$cookies.get('isPartner')) === 'true';
      },

  },

  mounted() {
    this.displaySpecialBanner();
  },

  watch :{
    orderChangedLines: function(){
      this.showAll = false
    }
  },


  data() {
    return {
      
      showAll: false,
      openUnpaid: false,
      openUpcoming: false,
      openRs: false,
      openChanged: false,
      isDisplaySpecialBanner : 0,
      }
    },

  methods: {
    showAllCards() {
      this.showAll = true;
    },

    // prepared minus ordered, shown as "-3" / "+2"; nothing when a quantity is missing
    quantityGap(changedOrderLine) {
      const ordered = changedOrderLine.qteCmd, prepared = changedOrderLine.qtePrep;
      if (ordered === null || ordered === undefined || prepared === null || prepared === undefined) return null;
      if (String(ordered).trim() === '' || String(prepared).trim() === '') return null;
      const gap = Number(prepared) - Number(ordered);
      return Number.isFinite(gap) ? Math.round(gap * 1000) / 1000 : null;
    },

    // same labels and colours as the invoices list "Échéance": "Dans N jours", "À échéance", "En retard de N jours"
    dueLabel(days) {
      if (days === null || days === undefined || days === '') return null;
      const count = Math.abs(Number(days));
      if (!Number.isFinite(count)) return null;
      const unit = count > 1 ? ' jours' : ' jour';
      if (days < 0) return { state: 'overdue', label: 'En retard de ' + count + unit };
      if (days == 0) return { state: 'soon', label: 'À échéance' };
      return { state: days <= 7 ? 'soon' : 'ok', label: 'Dans ' + count + unit };
    },

    markIsIiewedChangedOrderLine(changedOrderLine) {
        this.$store.dispatch('notification/markChangedOrderLineAsViewed', {numBc: changedOrderLine.numBc,codArt: changedOrderLine.codArt});
    },

    displaySpecialBanner() {
      BannerApi.displaySpecialBanner().then((result) => {
        this.isDisplaySpecialBanner = result;
      }).finally(() => {
        
      })
    },


  }
};
</script>



<template>
  <div>
    <!-- <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical> -->
    <Horizontal v-if="layoutType === 'vertical'" :layout="layoutType" class="zoom-container">

      <!-- ── Factures impayées ─────────────────────────────────────────────
           Financial standing alert: one collapsed banner (red accent). -->
      <div
        v-if="isUnpaidInvoicesNotificationEnabled && unpaidCount && canShowNotices"
        class="notice-alert notice-alert--unpaid"
      >
        <div
          class="notice-alert__bar"
          role="button"
          tabindex="0"
          @click="openUnpaid = !openUnpaid"
          @keyup.enter="openUnpaid = !openUnpaid"
        >
          <span class="notice-alert__icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="7.5" x2="12" y2="13" />
              <line x1="12" y1="16.5" x2="12.01" y2="16.5" />
            </svg>
          </span>

          <span class="notice-alert__text">
            <span class="notice-alert__title">
              {{ unpaidCount }} facture<template v-if="unpaidCount > 1">s</template>
              impayée<template v-if="unpaidCount > 1">s</template>
            </span>
            <span class="notice-alert__subtitle">
              Merci de régulariser votre situation auprès de notre service comptabilité.
            </span>
          </span>

          <span class="notice-alert__action">
            <span class="notice-alert__action-label">{{ openUnpaid ? 'Masquer' : 'Voir le détail' }}</span>
            <svg class="notice-alert__chevron" :class="{ 'is-open': openUnpaid }" viewBox="0 0 24 24"
                 width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        <div v-if="openUnpaid" class="notice-alert__detail">
          <div class="notice-table-wrap">
            <table class="notice-table">
              <thead>
                <tr>
                  <th>Numéro</th>
                  <th>Date</th>
                  <th class="text-right">Total TTC (TND)</th>
                  <th class="text-right">Reste à payer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in unpaidInvoices" :key="'unpaid-' + index">
                  <td class="notice-table__ref">{{ invoice.invoiceNumber }}</td>
                  <td class="notice-table__muted">{{ invoice.invoiceDate }}</td>
                  <td class="text-right">{{ invoice.amount }}</td>
                  <td class="text-right notice-table__due">{{ invoice.soldeAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ── Échéances à venir ─────────────────────────────────────────────
           Invoices still to pay but not overdue yet (the overdue ones are in "Factures impayées"),
           with the days left as in the invoices list "Échéance" column. Collapsed by default. -->
      <div
        v-if="isUpcomingDueInvoicesNotificationEnabled && upcomingDueCount && canShowNotices && canSeeInvoiceBalances"
        class="notice-alert notice-alert--upcoming"
      >
        <div
          class="notice-alert__bar"
          role="button"
          tabindex="0"
          @click="openUpcoming = !openUpcoming"
          @keyup.enter="openUpcoming = !openUpcoming"
        >
          <span class="notice-alert__icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3.5" y="5" width="17" height="15" rx="2" />
              <line x1="3.5" y1="9.5" x2="20.5" y2="9.5" />
              <line x1="8" y1="3" x2="8" y2="6.5" />
              <line x1="16" y1="3" x2="16" y2="6.5" />
              <polyline points="12 12.5 12 15 14 16.2" />
            </svg>
          </span>

          <span class="notice-alert__text">
            <span class="notice-alert__title">
              {{ upcomingDueCount }} échéance<template v-if="upcomingDueCount > 1">s</template> de paiement à venir
            </span>
            <span class="notice-alert__subtitle">
              Factures non encore échues<template v-if="nextUpcomingDue">, {{ nextUpcomingDue }}</template>.
            </span>
          </span>

          <span class="notice-alert__action">
            <span class="notice-alert__action-label">{{ openUpcoming ? 'Masquer' : 'Voir le détail' }}</span>
            <svg class="notice-alert__chevron" :class="{ 'is-open': openUpcoming }" viewBox="0 0 24 24"
                 width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        <div v-if="openUpcoming" class="notice-alert__detail">
          <div class="notice-table-wrap">
            <table class="notice-table">
              <thead>
                <tr>
                  <th>Numéro</th>
                  <th>Date</th>
                  <th class="text-right">Total TTC (TND)</th>
                  <th class="text-right">Reste à payer</th>
                  <th class="text-right">Échéance</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in upcomingDueInvoices" :key="'upcoming-' + index">
                  <td class="notice-table__ref">{{ invoice.invoiceNumber }}</td>
                  <td class="notice-table__muted">{{ invoice.invoiceDate }}</td>
                  <td class="text-right">{{ invoice.amount }}</td>
                  <td class="text-right notice-table__due">{{ invoice.soldeAmount }}</td>
                  <td class="text-right">
                    <span v-for="due in [dueLabel(invoice.remainingDaysToPay)].filter(Boolean)" :key="due.state" class="notice-due" :class="'notice-due--' + due.state">{{ due.label }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ── Retenue à la source pas encore déclarée ───────────────────────── -->
      <div
        v-if="isInvoiceWithoutRsNotificationEnabled && rsCount && canShowNotices"
        class="notice-alert notice-alert--rs"
      >
        <div
          class="notice-alert__bar"
          role="button"
          tabindex="0"
          @click="openRs = !openRs"
          @keyup.enter="openRs = !openRs"
        >
          <span class="notice-alert__icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
              <polyline points="14 3 14 8 19 8" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="9" y1="17" x2="13" y2="17" />
            </svg>
          </span>

          <span class="notice-alert__text">
            <span class="notice-alert__title">
              {{ rsCount }} retenue<template v-if="rsCount > 1">s</template> à la source
              pas encore déclarée<template v-if="rsCount > 1">s</template>
            </span>
            <span class="notice-alert__subtitle">
              À déclarer sur la plateforme TEJ.
            </span>
          </span>

          <span class="notice-alert__action">
            <span class="notice-alert__action-label">{{ openRs ? 'Masquer' : 'Voir le détail' }}</span>
            <svg class="notice-alert__chevron" :class="{ 'is-open': openRs }" viewBox="0 0 24 24"
                 width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        <div v-if="openRs" class="notice-alert__detail">
          <div class="notice-table-wrap">
            <table class="notice-table">
              <thead>
                <tr>
                  <th>Facture</th>
                  <th>Date</th>
                  <th class="text-right">Montant TTC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in invoiceWithoutRS" :key="'rs-' + index">
                  <td class="notice-table__ref">{{ invoice.factId }}</td>
                  <td class="notice-table__muted">{{ invoice.dateFactureAsStr }}</td>
                  <td class="text-right">{{ invoice.factTtcAsStr }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <a v-if="envSupplierName === 'omn'" class="notice-alert__link" href="/GUIDE-PLATEFORME-TEJ.pdf" target="_blank" rel="noopener">
            Consulter le guide de la plateforme TEJ
          </a>
        </div>
      </div>

      <template v-if="!isLegacyChangedOrderAlert">
      <!-- ── Commandes modifiées lors de la préparation ─────────────────────
           Same banner family as the two above (amber accent), collapsed by default like them;
           every changed line is listed, the table scrolls. -->
      <div
        v-if="isChangedOrdernlinesEnabled && visibleChangedOrderLines && visibleChangedOrderLines.length && canShowNotices"
        class="notice-alert notice-alert--changed"
      >
        <div
          class="notice-alert__bar"
          role="button"
          tabindex="0"
          @click="openChanged = !openChanged"
          @keyup.enter="openChanged = !openChanged"
        >
          <span class="notice-alert__icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="20" r="1.5" />
              <circle cx="18" cy="20" r="1.5" />
              <path d="M2.5 3.5h2.6l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.2l1.6-6.8H6.2" />
            </svg>
          </span>

          <span class="notice-alert__text">
            <span class="notice-alert__title">
              {{ changedLinesCount }} article<template v-if="changedLinesCount > 1">s</template>
              modifié<template v-if="changedLinesCount > 1">s</template> lors de la préparation
            </span>
            <span class="notice-alert__subtitle">
              Quantités préparées différentes des quantités commandées<template v-if="changedOrdersCount > 1"> sur {{ changedOrdersCount }} commandes</template>.
            </span>
          </span>

          <span class="notice-alert__action">
            <span class="notice-alert__action-label">{{ openChanged ? 'Masquer' : 'Voir le détail' }}</span>
            <svg class="notice-alert__chevron" :class="{ 'is-open': openChanged }" viewBox="0 0 24 24"
                 width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        <div v-if="openChanged" class="notice-alert__detail">
          <div class="notice-table-wrap">
            <table class="notice-table">
              <thead>
                <tr>
                  <th>Commande</th>
                  <th>Article</th>
                  <th class="text-right">Commandé</th>
                  <th class="text-right">Préparé</th>
                  <th class="text-right">Écart</th>
                  <th v-if="role == 0"><span class="sr-only">Ne plus afficher</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(changedOrderLine, index) in orderChangedLines" :key="'changed-' + index">
                  <td class="notice-table__order">
                    <span class="notice-table__ref">{{ changedOrderLine.numBc }}</span>
                    <span class="notice-table__sub">{{ changedOrderLine.dateHour }}</span>
                  </td>
                  <td class="notice-table__article">{{ changedOrderLine.libArt }}</td>
                  <td class="text-right notice-table__qty notice-table__cmd" data-label="Commandé">{{ changedOrderLine.qteCmd }}</td>
                  <td class="text-right notice-table__due notice-table__qty notice-table__prep" data-label="Préparé">{{ changedOrderLine.qtePrep }}</td>
                  <td class="text-right notice-table__gap">
                    <span v-if="quantityGap(changedOrderLine) !== null" class="notice-gap"
                          :class="{ 'notice-gap--less': quantityGap(changedOrderLine) < 0 }">
                      {{ quantityGap(changedOrderLine) > 0 ? '+' : '' }}{{ quantityGap(changedOrderLine) }}
                    </span>
                  </td>
                  <td v-if="role == 0" class="text-right notice-table__action">
                    <button type="button" class="notice-table__dismiss" title="Ne plus afficher" aria-label="Ne plus afficher"
                            @click="markIsIiewedChangedOrderLine(changedOrderLine)">
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                           stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <line x1="6" y1="6" x2="18" y2="18" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </template>
      <!-- CAB: "Commande modifiée" cards as before the banner (same data, visibility rule and "Ne plus afficher" action) -->
      <template v-else>
            <div v-if="isChangedOrdernlinesEnabled && visibleChangedOrderLines && visibleChangedOrderLines.length 
          && ((role == 1 && $route.path === '/catalogue') || (role == 0 && $route.path !== '/'))" class="row" >
        <div v-for="(changedOrderLine, index) in visibleChangedOrderLines"
            :key="index"
            class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2 mb-3 mt-1">
            
          <div class="card h-100 mx-3" 
              style="border-top-left-radius: 0; border-top-right-radius: 0; 
                      border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; 
                      border-top: 2px solid red;">
            
            <div class="flex-card py-2 px-2">
              
              


              <h6 class="mb-2 text-uppercase text-danger">
                  <div class="row">
                      <div class="col-10 mx-auto my-auto">
                          <div class="font-size-12 font-weight-bold ">Commande modifiée</div>
                      </div>
                      <div class="col-2 text-right">
                        <div v-if="role == 0"
                            class="close-order-line-btn" title="Ne plus afficher"
                            @click="markIsIiewedChangedOrderLine(changedOrderLine)">
                          <img src="@/assets/images/close-circle.svg" width="20" height="20" />
                        </div>
                      </div>
                  </div>
              </h6>

              <h6 class="mb-2 ">
                <div class="font-size-12 text-dark font-weight-bold   text-uppercase">{{ changedOrderLine.libArt }}</div>
                <span class="text-muted small">{{ changedOrderLine.numBc }}, {{ changedOrderLine.dateHour }}</span>

              </h6>

              <div class="mt-auto">
                <div class="text-muted small">
                </div>

                <strong>{{ changedOrderLine.qteCmd }} commandés &#10230;  <strong class="text-danger">{{ changedOrderLine.qtePrep }} préparés</strong></strong>
              </div>
              
            </div>
          </div>

        </div>

        <div v-if="!showAll && (orderChangedLines && orderChangedLines.length > maxPerRow)" 
            class="showMore w-100 mr-md-4 mr-2" 
            @click="showAllCards">
          Afficher plus ...
        </div>
      </div>
      </template>

      <div class="row m-4" v-if="isDisplaySpecialBanner && isBannerNewYearEnabled" >
        <div class="col-12 wishes-container p-0 m-0" style="border-radius:5px;"> 
          <div class="text-center" >

            <p style="letter-spacing: 2px; font-size: 45px; font-weight: 700; 
                font-family: 'Dancing Script', cursive; font-style: italic;text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);" 
                class="m-0  animated-text text-danger"> 
              Joyeuse Année {{isDisplaySpecialBanner}}
            </p>


            <p class="mt-0 d-none d-lg-block text-dark m-0 p-0 " 
            style="letter-spacing: 2px; font-size: 30px; font-weight: 700; 
                font-family: 'Dancing Script', cursive; font-style: italic;text-shadow: 2px 2px 4px #f46a6a;" >
                Nous vous souhaitons une année pleine de bonheur et de prospérité
            </p>

          </div>
        </div>
      </div>

      <slot />
    </Horizontal>
  </div>
</template>

<style >
   @media screen and (min-width: 1390px) {
    .zoom-container {
        zoom: 80%;
    } 
  }
  @media screen and (min-width: 1650px) {
    .zoom-container {
        zoom: 100%;
    } 
  }

  @media screen and (max-width: 1390px) {
    .zoom-container {
        zoom: 75%;
    } 

  }

  @media screen and (max-width: 800px) {
    .zoom-container {
        zoom: 60%;
    }
  } 

  @media screen and (max-width: 500px) {
    .zoom-container {
        zoom: 100%;
    } 
  }

  .wishes-container {
    background-image: url('~@/assets/images/wishes.jpg'); 
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 20px;
    color: #fff; 
    background-color: #fff;
}

@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@800&display=swap');

@keyframes textAnimation {
      0%, 100% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.8;
      }
    }

    .animated-text {
      letter-spacing: 2px;
      font-size: 35px;
      font-weight: 700;
      font-family: 'Dancing Script', cursive;
      font-style: italic;
      text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);
      animation: textAnimation 2s infinite; /* Adjust the duration as needed */
    }


.flex-card {
  flex: 1 1 calc(100% / 1 - 16px); /* default 1 per row */
  min-width: 280px;
  max-width: 290px;
  display: flex;
  flex-direction: column;
}

@media (min-width: 576px) {
  .flex-card {
    flex: 1 1 calc(50% - 16px);
  }
}

@media (min-width: 768px) {
  .flex-card {
    flex: 1 1 calc(33.33% - 16px);
  }
}

@media (min-width: 992px) {
  .flex-card {
    flex: 1 1 calc(25% - 16px);
  }
}

@media (min-width: 1200px) {
  .flex-card {
    flex: 1 1 calc(16.66% - 16px);
  }
}

/* ── Alert banners: factures impayées / retenue à la source ──────────────────
   One family of full-width banners with a left accent rail; the accent colour
   tells them apart (red: unpaid, indigo: retenue, amber: commande modifiée).
   All three are collapsed by default: one line each until expanded. */

.notice-alert {
  position: relative;
  margin: 0.5rem 1rem 0.75rem;
  border-radius: 10px;
  border: 1px solid transparent;
  border-left-width: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
}

.notice-alert__bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
}

.notice-alert__bar:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
}

.notice-alert__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 50%;
}

.notice-alert__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
  line-height: 1.3;
}

.notice-alert__title {
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.notice-alert__subtitle {
  font-size: 0.78rem;
  opacity: 0.85;
}

.notice-alert__action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

.notice-alert__chevron {
  transition: transform 0.2s ease;
}

.notice-alert__chevron.is-open {
  transform: rotate(180deg);
}

.notice-alert__detail {
  padding: 0 14px 12px;
}

.notice-table-wrap {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: auto;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.75);
}

.notice-table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.notice-table thead th {
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.96);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
  white-space: nowrap;
}

.notice-table tbody td {
  padding: 7px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  vertical-align: middle;
  white-space: nowrap;
}

.notice-table tbody tr:last-child td {
  border-bottom: 0;
}

.notice-table__ref {
  font-weight: 700;
  color: #0f172a;
}

.notice-table__muted {
  color: #64748b;
}

.notice-table__due {
  font-weight: 700;
}

.notice-alert__link {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.76rem;
  font-weight: 600;
  text-decoration: underline;
}

/* A page's own top spacer is only needed when no alert banner sits above it (the banner already leaves space under itself). */
.notice-alert ~ * > .page-top-spacer {
  padding-top: 0 !important;
}

/* Factures impayées — red, money you owe */
.notice-alert--unpaid {
  background: linear-gradient(180deg, #fff8f8 0%, #fff1f2 100%);
  border-color: rgba(225, 29, 72, 0.16);
  border-left-color: #e11d48;
  color: #881337;
}

.notice-alert--unpaid .notice-alert__icon {
  background: rgba(225, 29, 72, 0.12);
  color: #be123c;
}

.notice-alert--unpaid .notice-table__due {
  color: #be123c;
}

.notice-alert--unpaid .notice-alert__link {
  color: #be123c;
}

/* Échéances à venir — sky blue, a reminder rather than a problem */
.notice-alert--upcoming {
  background: linear-gradient(180deg, #f8fbff 0%, #eff6ff 100%);
  border-color: rgba(2, 132, 199, 0.16);
  border-left-color: #0284c7;
  color: #0c4a6e;
}

.notice-alert--upcoming .notice-alert__icon {
  background: rgba(2, 132, 199, 0.12);
  color: #0369a1;
}

.notice-alert--upcoming .notice-table__due {
  color: #0c4a6e;
}

/* days left to pay: same colours as the invoices list pills */
.notice-due { display: inline-block; padding: .15rem .55rem; border-radius: 999px; font-size: 12px; font-weight: 700; line-height: 1.3; white-space: nowrap; }
.notice-due--ok { color: #344054; background: #f2f4f7; }
.notice-due--soon { color: #c2410c; background: #fff1e6; }
.notice-due--overdue { color: #b42318; background: #fdecea; }

/* Retenue à la source — indigo/slate, an administrative filing to do */
.notice-alert--rs {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  border-color: rgba(79, 70, 229, 0.16);
  border-left-color: #4f46e5;
  color: #312e81;
}

.notice-alert--rs .notice-alert__icon {
  background: rgba(79, 70, 229, 0.12);
  color: #4338ca;
}

.notice-alert--rs .notice-alert__link {
  color: #4338ca;
}

/* Commande modifiée — amber, an order that changed during preparation */
.notice-alert--changed {
  background: linear-gradient(180deg, #fffaf3 0%, #fff5e9 100%);
  border-color: rgba(180, 83, 9, 0.18);
  border-left-color: #d97706;
  color: #7c2d12;
}

.notice-alert--changed .notice-alert__icon {
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
}

/* table text stays neutral; only "Préparé" and the gap pill carry the accent */
.notice-alert--changed .notice-table tbody td {
  color: #0f172a;
}

.notice-alert--changed .notice-table tbody td.notice-table__due {
  color: #b45309;
  font-weight: 700;
}

.notice-table__sub {
  display: block;
  margin-top: 1px;
  font-size: 0.72rem;
  color: #64748b;
}

.notice-table tbody td.notice-table__article {
  min-width: 14rem;
  white-space: normal;
  font-weight: 600;
  color: #0f172a;
}

.notice-gap {
  display: inline-block;
  min-width: 2.5rem;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(100, 116, 139, 0.12);
  color: #334155;
  font-weight: 700;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.notice-gap--less {
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
}

.notice-table__dismiss {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.notice-table__dismiss:hover {
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
}

.notice-table__dismiss:focus-visible {
  outline: 2px solid #b45309;
  outline-offset: 1px;
}

/* phones: one compact block per line instead of a table scrolled sideways */
@media (max-width: 575px) {
  .notice-alert--changed .notice-table-wrap {
    max-height: 340px;
    overflow-x: hidden;
  }
  .notice-alert--changed .notice-table,
  .notice-alert--changed .notice-table tbody {
    display: block;
  }
  .notice-alert--changed .notice-table thead {
    display: none;
  }
  .notice-alert--changed .notice-table tbody tr {
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    grid-template-areas:
      "article article article action"
      "order   order   order   order"
      "cmd     prep    gap     gap";
    align-items: center;
    column-gap: 14px;
    row-gap: 3px;
    padding: 10px 12px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  }
  .notice-alert--changed .notice-table tbody tr:last-child {
    border-bottom: 0;
  }
  .notice-alert--changed .notice-table tbody td {
    display: block;
    padding: 0;
    border: 0;
    white-space: normal;
    text-align: left !important;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__article {
    grid-area: article;
    min-width: 0;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__order {
    grid-area: order;
    font-size: 0.72rem;
  }
  .notice-alert--changed td.notice-table__order .notice-table__ref {
    font-weight: 600;
    color: #475569;
  }
  .notice-alert--changed td.notice-table__order .notice-table__sub {
    display: inline;
    margin-left: 6px;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__cmd {
    grid-area: cmd;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__prep {
    grid-area: prep;
  }
  .notice-alert--changed td.notice-table__qty::before {
    content: attr(data-label);
    margin-right: 5px;
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #64748b;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__gap {
    grid-area: gap;
    justify-self: end;
    text-align: right !important;
  }
  .notice-alert--changed .notice-table tbody td.notice-table__action {
    grid-area: action;
    justify-self: end;
    align-self: start;
    margin: -4px -6px 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .notice-alert__chevron,
  .notice-table__dismiss {
    transition: none;
  }
}

@media (max-width: 575px) {
  .notice-alert {
    margin: 0.5rem 0.5rem 0.75rem;
  }
  .notice-alert__bar {
    flex-wrap: wrap;
    gap: 8px;
  }
  .notice-alert__action {
    width: 100%;
    justify-content: flex-end;
  }
}

.showMore {
  width: 100%;
  text-align: right;
  cursor: pointer;
  font-weight: bold;
}

.close-order-line-btn {
  /*position: absolute;
  bottom: 2%;
  right: 2%;*/
  cursor: pointer;
  transition: transform .2s ease, opacity .2s ease;
}

.close-order-line-btn:hover {
  opacity: 0.85;
  transform: scale(1.1);
}


</style>
